import { getDataMapper, mapField } from "@/shared";

export const mapTariffStatisticFromServer = getDataMapper({
    daysLeft: mapField("days_left", Number),
    inventories: mapField("inventories"),
    clients: mapField("clients"),
    employees: mapField("employees"),
    points: mapField("points"),
});
